import { put } from 'redux-saga/effects';

export function* twoFactorSubmitResend(action) {
  const { payload = {} } = action;
  const {
    payload: formData = {},
    actionType = '',
    hash = '',
    otp = '',
  } = payload;

  const requestBody = {
    ...formData,
    hash,
    otp,
  };
  yield put({ type: `${actionType}_INITIATE`, payload: requestBody });
}
